export enum SideMenuEnum {
  Badge = 'Badge',
  DalyOverview = 'DalyOverview',
  Orders = 'Orders',
  Reports = 'Reports',
  Settings = 'Settings',
  LogOut = 'LogOut',
  ExpenseDuplicateReport = 'ExpenseDuplicateReport',
  AbsenzPlaner = 'AbsenzPlaner',
  PresenceList = 'PresenceList',
  Workflow = 'Workflow',
  AdminTool = 'AdminTool',
  AdminToolPerson = 'AdminToolPerson',
  AdminToolTimeModel = 'AdminToolTimeModel',
  // AdminToolDepartment = 'AdminToolDepartment',
  AdminToolHoliday = 'AdminToolHoliday',
  AdminList = 'AdminList',
  PersonalRoot = 'PersonalRoot',
  MasterDataRoot = 'MasterDataRoot',
}
